import { Box, Grid, Typography } from '@mui/material';
import { uniqueId } from 'lodash';

interface ListingContainerItemProps {
  label: string;
  key: string;
  component: React.ReactNode;
}
interface ListingContainerProps {
  title?: string;
  items?: Array<ListingContainerItemProps>;
  isFeatures?: boolean;
}

const ListingContainer: React.FC<ListingContainerProps> = ({
  title,
  items,
  isFeatures = false,
}) => {
  return (
    <Grid container>
      {title && (
        <Grid sx={{ my: 3 }} size={12}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Grid>
      )}
      <Grid container alignItems="flex-start" spacing={2} size={12}>
        {items?.map((item) => {
          // For features, use auto width with fixed max-width
          if (isFeatures) {
            return (
              <Grid
                key={uniqueId(item.key)}
                // No fixed grid size, let it take natural width
                sx={{
                  maxWidth: '220px', // Fixed max width for feature toggles
                  minWidth: { xs: '100%', sm: '180px' }, // Full width on mobile
                  mb: 2,
                }}
              >
                <Box>
                  <Typography variant="body1" fontWeight="fontWeightBold">
                    {item.label}
                  </Typography>
                  <Box>{item.component}</Box>
                </Box>
              </Grid>
            );
          }

          // For records, use the 1/3 on large and above, 1/2 on medium , full on xs approach
          return (
            <Grid
              key={uniqueId(item.key)}
              sx={{ mb: 2 }}
              size={{
                xs: 12,
                sm: 6,
                md: 6,
                lg: 4,
              }}
            >
              <Box>
                <Typography variant="body1" fontWeight="fontWeightBold">
                  {item.label}
                </Typography>
                <Box>{item.component}</Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

const ListingAssistantItem: React.FC<any> = ({ text, icon, button = null }) => {
  return (
    <Grid container sx={{ mt: 2 }}>
      <Grid sx={{ width: 48, mr: 1 }}>
        <Box component="img" sx={{ width: 48 }} src={icon} />
      </Grid>
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        direction="column"
        size="grow"
      >
        <Typography sx={{ px: 1 }} variant="body1">
          {text}
        </Typography>
        {button}
      </Grid>
    </Grid>
  );
};

export { ListingContainer, ListingAssistantItem };
